import { render, staticRenderFns } from "./reverse.vue?vue&type=template&id=136479db&scoped=true"
import script from "./reverse.vue?vue&type=script&lang=js"
export * from "./reverse.vue?vue&type=script&lang=js"
import style0 from "./reverse.vue?vue&type=style&index=0&id=136479db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136479db",
  null
  
)

export default component.exports